import removeEmpty from './removeEmpty';

type ComparisonResult = { [key: string]: any };

function replaceUndefined(value: any): any {
  if (Array.isArray(value)) {
    return value.map((item) => (item === undefined ? [] : item));
  } else if (typeof value === 'object') {
    return value === undefined ? {} : value;
  } else {
    return value === undefined ? '' : value;
  }
}

function compareObjects(obj1: any, obj2: any): ComparisonResult {
  const result: ComparisonResult = {};

  // Function to compare each property
  function compareProperty(key: string, value1: any, value2: any) {
    value1 = replaceUndefined(value1);
    value2 = replaceUndefined(value2);

    if (Array.isArray(value1) && Array.isArray(value2)) {
      result[key] = value1
        .map((item, index) => compareObjects(item, value2[index]))
        .filter((diff) => Object.keys(diff).length > 0);
    } else if (typeof value1 === 'object' && typeof value2 === 'object') {
      const diff = compareObjects(value1, value2);
      if (Object.keys(diff).length > 0) {
        result[key] = diff;
      }
    } else if (value1 !== value2) {
      result[key] = { old: value1, new: value2 };
    }
  }

  // Compare properties of obj1
  for (const key in obj1) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj1.hasOwnProperty(key) && obj2?.hasOwnProperty(key)) {
      compareProperty(key, obj1[key], obj2[key]);
    }
  }

  // Compare properties of obj2 that are not in obj1
  for (const key in obj2) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
      compareProperty(key, undefined, obj2[key]);
    }
  }

  return removeEmpty(result);
}

export default compareObjects;
